'use strict';

const jQuery = require('jquery');

const container = require('./../../core/container');

const hide = function() {
    if (container.get('prevent-hide-overlay') === true) {
        return;
    }

    jQuery('.cloud-overlay-menu').remove();
};

module.exports.show = function(config = {}) {
    if (container.get('prevent-hide-overlay') === true) {
        return;
    }

    let onClick = config.onClick || jQuery.noop;
    hide();

    let $overlay = jQuery('<div class="cloud-overlay-menu"></div>');

    if (config.isHideable) {
        $overlay.on('click', function() {
            onClick();
            $overlay.remove();
        });
    }

    jQuery('.cloud-toolbar-main').append($overlay);
};

module.exports.hide = hide;
